// extracted by mini-css-extract-plugin
module.exports = {"app":"src-app-app-d6234263"};